export default {
  data() {
    return {
      perms: [],
      updatePerm: false,
      deletePerm: false
    }
  },
  created() {
    this.perms = 'perms' in localStorage && localStorage.perms !== '' ? JSON.parse(localStorage.perms) : []
  },
  mounted() {
    this.$nextTick(() => {
      this.updatePerm = this.isShowBtn('update')
      this.deletePerm = this.isShowBtn('delete')
    })
  },
  methods: {
    // 是否显示这个按钮
    isShowBtn(perm) {
      let url = window.location.pathname.substr(5)
      let len = this.perms.length
      let pid = ''
      for (let i = 0; i < len; i++) {
        if (this.perms[i].url == url) {
          pid = this.perms[i].id
        }
      }
      for (let i = 0; i < len; i++) {
        if (this.perms[i].pid == pid && this.perms[i].perm == perm) {
          return true
        }
      }

      return false
    },
  },
}